import type { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';

/*
 * Skin for the org plugin's Group profile card.
 *
 * The card always renders a Parent group and a Child groups row, printing the
 * literal string "N/A" when the group has neither — two dead rows on most Hone
 * teams, since the GitHub org is flat.
 *
 * The two states differ in the DOM: a populated row renders `EntityRefLinks`
 * and so contains an anchor, while the empty one is bare text. `:has(a)` is the
 * distinction.
 *
 * `:not(:first-child)` protects the Entity ref row, which is also bare text but
 * is a real value, and is always rendered first. The email row and the links
 * group both carry anchors, so neither needs guarding. Position is not assumed
 * beyond "first" — the email row and links group are both conditional, so the
 * rows in between shift.
 */
const useStyles = makeStyles({
  root: {
    display: 'contents',

    '& [class*="MuiList-root"] > [class*="MuiListItem-root"]:not(:first-child):not(:has(a))':
      {
        display: 'none',
      },
  },
});

export function GroupProfileRows({ children }: { children: ReactNode }) {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
}
